module.exports = __webpack_public_path__ + "img/image01.ea06a34f.jpg";